import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

function MediaPlayer({ source, configProps, ...props }) {
  return (
    <ReactPlayer
      url={source}
      controls
      config={{
        file: {
          attributes: {
            controlsList: 'nodownload',
            disablePictureInPicture: true,
          },
        },
        youtube: {
          playerVars: { color: 'white', rel: 0 },
        },
        ...configProps,
      }}
      {...props}
    />
  );
}

MediaPlayer.defaultProps = {
  source: null,
  configProps: {},
};

MediaPlayer.propTypes = {
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  configProps: PropTypes.object,
};

export { MediaPlayer };
